import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { AUTHKEY } from '../../utils/keys.js';
import { routeConstants } from '../../utils/path-constants.js';

const allowedPages = new Set(['uam', 'dashboard', 'wallet']);

function Approval() {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const currentPath = location.pathname;
		localStorage.setItem('approval_link', currentPath);

		const token = localStorage.getItem(AUTHKEY);
		if (!token) {
			navigate(routeConstants.LOGIN);
			return;
		}

		const pathSegments = currentPath.trimStart().split('/');
		const redirectPage = pathSegments[2];

		if (redirectPage && allowedPages.has(redirectPage)) {
			navigate(`/${redirectPage}`);
		} else {
			localStorage.removeItem('approval_link');
		}
	}, []);

	return (
		<div>
			<div className='medium3' style={{ textAlign: 'center', margin: '20px 0px' }}>
				Redirecting...
			</div>
			<div style={{ justifyContent: 'center', display: 'flex' }}></div>
		</div>
	);
}

export default Approval;
